import BaseStyle from '@primevue/core/base/style';

var AccordionTabStyle = BaseStyle.extend({
  name: 'accordiontab'
});

export { AccordionTabStyle as default };
//# sourceMappingURL=index.mjs.map
